import Reflux from 'reflux';

export default Reflux.createActions({
  changeSortIndex: {},
  addCatalog: {},
  catalogEdit: {},
  catalogShowHiddenFields: {},
  clearCatalog: {},
  truncateCatalogFromStore: {},

  // manual
  manualEdit: {},
  manualUpdateValue: {},
  manualSave: {},
  manualCancelEdit: {},
});
